// 簡單的手動 Modal 外殼 - 避免 Bootstrap JS 依賴
const ModalShell = ({ title, size, onClose, children, footer }) => (
  <div
    className="modal fade show d-block"
    style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
    role="dialog"
    aria-modal="true"
    aria-labelledby="modal-shell-title"
  >
    <div className={`modal-dialog ${size ? `modal-${size}` : ''}`}>
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="modal-shell-title">{title}</h5>
          <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
        </div>
        {children}
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  </div>
);

export default ModalShell;
